import { render, staticRenderFns } from "./FleetDetailNavTab.vue?vue&type=template&id=58d46f00"
import script from "./FleetDetailNavTab.vue?vue&type=script&lang=ts"
export * from "./FleetDetailNavTab.vue?vue&type=script&lang=ts"
import style0 from "./FleetDetailNavTab.vue?vue&type=style&index=0&id=58d46f00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports